import React from 'react'
import './LoadingSpinner.css'

const LoadingSpinner = () => {
  return <div className="loader" data-testid="loader"></div>;
}

export default LoadingSpinner